import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { PageHeader } from '@/components/kit';
import { BackLink } from '@/components/record';
import ProductForm, { blankProduct } from '@/components/admin/ProductForm';
import { committed } from '@/shared/data';

export const route = { path: '/admin/products/new', layout: 'owner', access: "['Admin_c','Staff_c'].includes(profile)" };

export default function NewProduct() {
  const navigate = useNavigate();
  const [initial] = useState(blankProduct);
  const [saving, setSaving] = useState(false);

  async function create(payload) {
    setSaving(true);
    try {
      const res = await sdk.table('products_c').create(payload);
      const saved = committed(res, 'Product added');
      if (!saved) return;
      navigate(saved.Id ? `/admin/products/${saved.Id}` : '/admin/products');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-5xl">
      <BackLink to="/admin/products" label="Back to Products" />
      <PageHeader
        eyebrow="Products"
        title="New product"
        description="It gets its own page with a term picker and an order button. Renewals work like the plans."
      />
      <ProductForm
        initial={initial}
        onSubmit={create}
        saving={saving}
        submitLabel="Add product"
        busyLabel="Adding…"
        cancelTo="/admin/products"
      />
    </div>
  );
}
